import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useT, useLocale, apiLang } from "../lib/i18n";
import { Button } from "../components/ui/Button";

export function Forgot() {
  const t = useT();
  const { locale } = useLocale();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await api.forgotPassword(email.trim().toLowerCase(), apiLang(locale));
    } catch {
      // Deliberately ignored: never reveal whether the account exists.
    } finally {
      setBusy(false);
      setSent(true);
    }
  }

  return (
    <main className="page-scroll min-h-screen-d flex flex-col items-center justify-center px-6 bg-canvas">
      <div className="w-full max-w-xs flex flex-col items-center animate-rise">
        <h1 className="text-2xl font-semibold mb-8 text-center">{t("auth.forgotTitle")}</h1>

        {sent ? (
          <p className="text-sm text-fg-secondary text-center">{t("auth.forgotSent")}</p>
        ) : (
          <form onSubmit={submit} className="w-full space-y-3">
            <input
              className="input"
              type="email"
              required
              placeholder={t("auth.email")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              autoFocus
            />
            <Button type="submit" disabled={busy} fullWidth>
              {t("auth.forgotCta")}
            </Button>
          </form>
        )}

        <p className="mt-6 text-sm text-fg-secondary text-center">
          <Link to="/login" className="underline">
            {t("auth.loginCta")}
          </Link>
        </p>
      </div>
    </main>
  );
}
